/** Client-side hint — server normalizes before Rasayel send (default country 966). */
export function formatPhoneHint(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const digitsOnly = trimmed.replace(/[^\d+]/g, '');
  if (digitsOnly.startsWith('+0')) {
    return 'Invalid: remove the leading 0 after +. Use +966590571010, not +0590571010.';
  }
  if (/^0\d{8,10}$/.test(digitsOnly.replace(/^\+/, ''))) {
    return 'Local numbers like 05xxxxxxxx are OK — we convert to +9665xxxxxxxx on send.';
  }
  if (/^00\d+/.test(digitsOnly.replace(/^\+/, ''))) {
    return '00-prefixed numbers are OK — we convert 00966… to +966… on send.';
  }
  return null;
}
